/**
 * ## Error objects
 *
 * @module src/error
 */

'use strict';

const AuthenticationError = require('./authentication');
const AuthorizationError = require('./authorization');
const ConfigurationError = require('./configuration');
const DBError = require('./db');
const KDContextError = require('./kd-context');
const ValidationError = require('./validation');
const ParseError = require('./parse');


module.exports = {
    AuthenticationError,
    AuthorizationError,
    ConfigurationError,
    DBError,
    KDContextError,
    ValidationError,
    ParseError,
};



/** WEBPACK FOOTER **
 ** ./src/common/error/index.js
 **/